import YandexMap from "./../ymap";
import {VGMap} from "../../../../../../modules/index.esm";
import {ajax, listener, mergeDeepObject, normalizeData} from "../../../../../../modules/vegas/js/util";
import AirDatepicker from 'air-datepicker';

const Booking = {
	form: null,
	result: null,
	tabs: null,

	init() {
		this.form = document.getElementById('form-booking');
		this.result = document.getElementById('booking-result');
		this.tabs = document.getElementById('booking-tabs');

		if (!this.tabs) return;

		this.Set.address();
		this.Set.datetime();
	},

	toggle(el) {
		let target = el.getAttribute('href');
		if (!target) return;

		let tab = document.getElementById(target.slice(1));
		if (!tab) return;

		let tabActive = Booking.tabs.querySelectorAll('.book-tab.active');
		if (tabActive.length) {
			tabActive.forEach(function (elm) {
				elm.classList.remove('active');
				elm.classList.add('d-none');
			});
		}

		tab.classList.remove('d-none');
		tab.classList.add('active');

		if (tab.id === 'step-date') {
			let times = document.getElementById('booking-time')?.querySelector('.times'),
				now = new Date(),
				day = now.getDate();

			day = day < 10 ? "0" + day : day;

			let month = now.getMonth() + 1;
			month = month < 10 ? "0" + month : month;

			const year = now.getFullYear();
			const dateString = `${day}.${month}.${year}`;

			Booking.Get.timesAjax({
				date: now,
				formattedDate: dateString
			}, times);
		}

		if (tab.id === 'step-form') {
			Booking.result.classList.add('show');
		} else {
			Booking.result.classList.remove('show');
		}
	},

	submit(el) {
		let timeOut = 1000;

		const loader = document.getElementById('booking-loader');
		const wrapper = document.getElementById('booking-wrapper');
		const alert = document.getElementById('booking-alert');

		loader?.classList.remove('d-none');

		setTimeout(() => {
			wrapper?.classList.add('d-none');
			loader?.classList.add('show');
		}, 300);

		let data = new FormData(el);

		ajax.post(el.getAttribute('action'), data, false, function(status, result) {
			let _error = alert?.querySelector('.ui-status-error'),
				_success = alert?.querySelector('.ui-status-success');

			setTimeout(() => {
				if (status === 'error' || result.error) {
					_error.classList.add('show');
					_error.querySelector('.response').innerHTML = result.message;
				} else {
					_success.classList.add('show');
					_success.querySelector('.response').innerHTML = result.message;

					const dataDate = result.date.split('.');
					const dataTime = result.time.split(':');
					const resultBooking = document.getElementById('result-booking');
					const date = new Date(dataDate[2], dataDate[1], dataDate[0], dataTime[0], dataTime[1], dataTime[2]);

					let address = result.address,
						months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'сентября', 'октября', 'ноября', 'декабря'];

					resultBooking.innerHTML = '<b>' + dataDate[0] + ' ' + months[date.getMonth()] + ' в ' + dataTime[0] + ':' + dataTime[1] + '</b> <br> по адресу <b>' + address + '</b>';
				}

				alert?.classList.remove('d-none');
				loader?.classList.remove('show');

				setTimeout(() => {
					alert?.classList.add('show');
					loader?.classList.add('d-none');
				}, 300);
			}, timeOut);
		});
	},

	Get: {
		data() {
			let address = Booking.form.querySelector('[name="book-address"]'),
				service = Booking.form.querySelector('[name="book-service"]'),
				datetime = Booking.form.querySelector('[name="book-date"]');

			return  {
				address: address.value,
				service: service.value,
				datetime: datetime.value,
			}
		},

		timesAjax(obj, times) {
			times.innerHTML = '';

			ajax.get('/booking/times', {
				date: obj.formattedDate,
				store_id: Booking.Get.data().address,
				service_id: Booking.Get.data().service,
			}, function(status, data) {
				if (data.times.length) {
					for (let i = 0; i < data.times.length; i++) {
						let t = data.times[i];
						let time = document.createElement('div');
						time.classList.add('time');
						time.setAttribute('data-vg-toggle', 'choose-datetime');
						time.setAttribute('data-date', obj.date);
						time.setAttribute('data-date-formatted', obj.formattedDate);
						time.setAttribute('data-time', t);
						time.innerText = t;

						times.append(time);
					}
				} else {
					document.getElementById('booking-time').querySelector('.alert-empty').classList.remove('d-none');
				}
			});
		}
	},

	Set: {
		address() {
			let address = Booking.form.querySelector('[name="book-address"]');
			address.value = document.querySelector('[data-vg-toggle="choose-store"].active')?.dataset.id;

			const mapBooking = document.getElementById('yaMapBookStore');
			if (mapBooking) {
				new YandexMap().include(function (){
					VGMap.init(mapBooking, {
						callback: {
							afterInitMap: function (map, params, _this) {
								VGMapBookingStore.run(map, params, _this);
							}
						}
					});
				});

				const VGMapBookingStore = {
					run: function (map, params, self) {
						let collection = self.PlaceMark.set(map, params);

						collection.forEach(function (mark, index) {
							if (index !== 0) {
								mark.options.set('visible', false);
							}
						});

						listener('click', '[data-vg-toggle="choose-store"]', function (el, e) {
							e.preventDefault();

							let list = el.closest('.list'),
								key = Number(el.dataset.key),
								title = el.querySelector('.title').innerText || '',
								description = el.querySelector('.description')?.innerText || '',
								id = el.dataset.id;

							[... list.querySelectorAll('[data-vg-toggle]')].forEach((elm) => elm.classList.remove('active'));

							el.classList.add('active');

							collection.forEach(function (mark, index) {
								mark.options.set('visible', false);

								if (key === index) {
									mark.options.set('visible', true);
									map.setCenter(mark.geometry._coordinates)
								}
							});

							address.value = id;

							Booking.result.querySelector('#book-address').innerText = title;
							Booking.result.querySelector('#book-description').innerText = description;
						});
					},
				}
			}
		},

		service(el) {
			let service = Booking.form.querySelector('[name="book-service"]');
			document.getElementById('booking-services')?.querySelector('.active')?.classList.remove('active');

			el.classList.add('active');

			let result = document.getElementById('booking-result--service'),
				title = el.dataset.title,
				price = el.dataset.price,
				time = el.dataset.time;

			service.value = el.dataset.id;

			if (!result) return;

			result.classList.remove('d-none');
			result.querySelector('.title').innerText = title;
			result.querySelector('#book-price').innerText = price;
			result.querySelector('#book-time').innerText = time;

			document.getElementById('step-services').querySelector('.btn-primary[data-vg-toggle="booking"]')?.classList.remove('disabled');
		},

		datetime() {
			const calendarBooking = document.getElementById('booking-calendar');
			if (calendarBooking) {
				let currentDay = document.getElementById('booking-time')?.querySelector('.current-date'),
					times = document.getElementById('booking-time')?.querySelector('.times'),
					now = new Date(),
					formatter = new Intl.DateTimeFormat("ru", {
						month: "long",
						day: "numeric",
						weekday: "long",
					});

				currentDay.classList.remove('d-none');
				currentDay.innerText = formatter.format(now);
				times.innerHTML = '';

				document.getElementById('booking-result--datetime').classList.remove('d-none');
				let result = document.getElementById('book-date');
				result.innerHTML = formatter.format(now);

				let params = normalizeData(calendarBooking.dataset.params);

				new AirDatepicker('#booking-calendar', mergeDeepObject(params, {
					selectedDates: [now],
					onSelect(object) {
						document.getElementById('step-date')?.querySelector('.btn-primary[data-vg-toggle="booking"]')?.classList.add('disabled');
						result.innerHTML = formatter.format(object.date);

						document.getElementById('booking-time').querySelector('.alert-empty').classList.add('d-none');

						Booking.Get.timesAjax(object, times);
					}
				}));
			}
		},

		setDateTime(el) {
			let datetime = Booking.form.querySelector('[name="book-date"]'),
				times = document.getElementById('booking-time')?.querySelector('.times');

			[... times.querySelectorAll('.time.active')].forEach((el) => {
				el.classList.remove('active');
			});

			el.classList.add('active');

			let date = el.dataset.date || '',
				formattedDate = el.dataset.dateFormatted,
				time = el.dataset.time || '';

			datetime.value = formattedDate + ' ' + time;

			let result = document.getElementById('book-date'),
				formatter = new Intl.DateTimeFormat("ru", {
					month: "long",
					day: "numeric",
					weekday: "long",
				});

			result.innerText =  formatter.format(new Date(date)) + ', ' + time

			document.getElementById('step-date').querySelector('.btn-primary[data-vg-toggle="booking"]')?.classList.remove('disabled');
		}
	}
}


export default Booking;
